import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequestHelper } from '@shared/helper/request.helper';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { APIConstant } from '@shared/constant/api.constant';
import { NavigationConstant } from '@shared/constant/navigation.constant';
import { MessageConstant } from '@shared/constant/message.constant';
import { paymentVaStorage } from '@shared/storage/payment-va.storage';

@Component({
  selector: 'app-inquiry-bri-snap',
  templateUrl: './inquiry-bri-snap.component.html',
  styleUrls: ['./inquiry-bri-snap.component.css']
})
export class InquiryBriSnapComponent implements OnInit  {
  hostname: any = environment.hostName; 
  form: FormGroup;
  isLoading = false;
  isSubmitted = false;

  maxLength = 28;
  imagePath = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/bank/bri.png';
  moduleName = 'BRI VA (SNAP)';


  constructor(
    private apiService: RequestHelper,
    private router: Router,
    private storage: paymentVaStorage
) {
    this.form = new FormBuilder().group({
        virtualAccountNo: [null, [Validators.required, Validators.maxLength(this.maxLength)]]
    });
}

ngOnInit() {
  this.storage.imagePath = this.imagePath;
  this.storage.moduleName = this.moduleName;
}

submitInquiry() {
  this.isSubmitted = true;
  if (!this.form.valid) {
      return;
  }
  this.isLoading = true;
  this.storage.data.virtualAccountNo = this.form.get('virtualAccountNo').value;

  const payload = {
      virtualAccountNo: this.storage.data.virtualAccountNo
  };

  this.apiService.post(environment.apiUrl + APIConstant.BRI_SNAP_INQUIRY, JSON.stringify(payload))
      .subscribe(
          (data) => {
              if (data == null) {
                  this.openDialog(MessageConstant.CANNOT_PROCESS);
              } else {
                  this.getDataResponse(data);
              }
          },
          () => {
              this.isLoading = false;
              this.openDialog(MessageConstant.CANNOT_PROCESS);
          }
      );
}

getDataResponse(data: any) {
  this.isLoading = false;
  if (data.responseCode === '2002400') {
      this.storage.inquiryResult = data;
      this.router.navigate([NavigationConstant.BRI_SNAP_PAYMENT]);
  } else {
    this.openDialog(data.responseMessage || MessageConstant.CANNOT_PROCESS);
  }
}

openDialog(result) {
  this.apiService.openDialog(result, NavigationConstant.BRI_SNAP_INQUIRY);
}


}

